export interface IReceiptV2 {
  officeId: string;
  officeName: string;
  // null for receipts that aren't tied to a shift (e.g. ListingFee receipts on postings).
  shiftDate: string | null;
  shiftId: string;
  status: ReceiptV2Status;
  totalCharge: number;
  totalRefund: number;
  transactionDate: string;
  type: ReceiptType;
  postingId?: string;
}

export enum ReceiptV2Status {
  Pending = 'pending',
  Refunded = 'refunded',
  Succeeded = 'succeeded',
}

export enum ReceiptType {
  OnsiteInterview = 'onsite_interview',
  Shift = 'shift',
  ListingFee = 'listing_fee',
}
